/* eslint no-template-curly-in-string: 0 */

import { PAYMENT_NETWORKS, FLOW_TYPES, PAYMENT_STATUSES } from "../../utils/enums";
import physicalDebitCardLogo from "../../assets/images/mastercard-logo.png";

const disclosureOfFeesFaq = {
  answer: `Disbursement Card is issued by Pathward N.A., Member FDIC, pursuant to license by Mastercard International Incorporated. Mastercard is a registered trademark, and the circles design is a trademark of Mastercard International Incorporated. No cash access or recurring payments. Can be used where Debit Mastercard is accepted. Card valid for up to 12 months. Funds do not expire and may be available after card expiration date; inactivity fee may apply. Card terms, conditions and fees apply.`,
  question: "About Mastercard Physical Debit Card"
};

export const physicalDebitCard = {
  id: PAYMENT_NETWORKS.PHYSICALDEBITCARD_BLACKHAWK_MASTERCARD,
  displayName: "Mastercard Physical Debit Card",
  paywall: {
    tile: {
      displayName: ["Mastercard Physical Debit Card"],
      tagline: ["Delivers in 10-14 business days"],
      description: [
        // "Immediate cash.",
        "For use online or in-store.",
      ],
      // btnLabel: "Go",
      logo: physicalDebitCardLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.COLLECT_ADDRESS,
    title: "Mastercard Physical Debit Card",
    description: [
      "Please confirm your mailing address. Allow 10-14 business days for delivery."
    ],
    showStartOver: true,
  },
  acceptPayment: {
    title: ["Confirm Payment"],
    autoAcceptDurationInSeconds: 10,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.COLLECT_ADDRESS,
    description: "Please confirm your mailing address is correct as displayed below. Once submitted, the delivery address cannot be changed.",
    btnLabel: 'SUBMIT',
    imgSrc: physicalDebitCardLogo,
    secondaryText: [
      {
        string: "We encourage you to use your card once every 12 months to avoid inactivity fees. After one year of inactivity, monthly fees of $5.95 occur.",
        props: {
          style: {
            fontSize: "0.8rem",
            lineHeight: "1.2",
            padding: "0 1em",
            display: "block",
            textAlign: "center",
            marginBottom: "2em",
          }
        }
      }
    ]
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        disclosureOfFeesFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        disclosureOfFeesFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        disclosureOfFeesFaq
      ],
    }
  },
  networkSelectionAccepted: {
    imgSrc: physicalDebitCardLogo,
    title: ["Success!"],
    description: [
      "Please check your email ",
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatEmailAddressOrMobilePhoneNumber',
          }
        ],
        props: {
          className: 'payment-recipientEmail'
        }
      },
      " for details regarding your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      " for ",
      {
        string: "${payment.acceptedAmount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.acceptedCurrency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      ". Your card should arrive within 10-14 business days and will include details for your use."
    ],
    secondaryText: [
      "Upon receipt, please treat this card like cash and care for it accordingly to avoid loss or theft."
    ]
  },
  paymentComplete: {
    title: "Payment Complete",
    initial: {
      description: [
        "Success! A physical debit card for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " will be mailed to you in approximately 10-14 business days."
      ],
      secondaryText: [
        "A confirmation will be ",
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatPaymentNetworkRecipientType',
            }
          ],
        },
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatEmailAddressOrMobilePhoneNumber',
            },
          ],
          props: {
            className: 'payment-recipientEmail'
          }
        },
        "."
      ]
    },
    revisit: {
      description: [
        "Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: "payment-recipientEmail"
          }
        },
        " for details regarding your payment for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount"
          }
        },
        ". Expect your physical debit card to be received at your address on file in 10-14 business days.",
      ],
      secondaryText: " "
    },
    imgSrc: physicalDebitCardLogo
  },
  onHold: {
    imgSrc: physicalDebitCardLogo,
  }
};

export default physicalDebitCard;
